const strongs = document.querySelectorAll(".collection__title strong, .rich-text__blocks strong, .ais-title strong");

strongs.forEach(strong => {
  // wrap strong content
  strong.style.display = "inline-block";

  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.setAttribute("class", "strong-underline");
  svg.setAttribute("viewBox", "0 0 100 20");
  svg.setAttribute("preserveAspectRatio", "none");

  const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
path.setAttribute("d", "M2 10 Q50 16 98 10");

// White underline only for .ais-title
if (strong.closest(".ais-title")) {
  svg.classList.add("white-underline");
}
  svg.appendChild(path);
  strong.appendChild(svg);

  const length = path.getTotalLength();
  path.style.strokeDasharray = length;
  path.style.strokeDashoffset = length;

  window.addEventListener("scroll", () => {
    const rect = strong.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const progress = 1 - rect.top / windowHeight;

    if (progress > 0 && progress < 1) {
      path.style.strokeDashoffset = length * (1 - progress);
    }
  });
});
